export default async function ({
	$auth, app, route, redirect,
}) {
	const { fullPath } = route;
	const cookie = app.$cookies.get('skolkovo_id_user');

	if (
		!$auth.loggedIn
		&& cookie
		&& !fullPath.includes('autologin')
		&& !fullPath.includes('logout')
	) {
		const domain = 'https://www.skolkovo.ru';
		const params = `?return_url=${domain}${fullPath}`;

		redirect(`https://sk.skolkovo.ru/test_skolkovo_id_redirect${params}`);
	}
}
